//function common header crm links
export const automationHeaderLinks = (t) => {
    const basePath = `/admin/automation`;

    console.log("headerLinks function executed"); // Debug log

    return [
      { title: t("Automation Config"), link: `${basePath}/list` },
      { title: t("Automation Events"), link: `${basePath}/events/list` },
    ];
};